import React from 'react';
import { FaFacebook, FaTwitter, FaGithub, FaInstagram, FaYoutube } from 'react-icons/fa';
import p1 from "../Accests/p1.jpg"

const Owner = () => {
    return (

        <div className="bg-gray-900 min-h-screen flex items-center justify-center py-12 px-6">

            <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full flex flex-col lg:flex-row">
                {/* Profile Section */}
                <div className="w-full lg:w-3/5 p-6 lg:p-12 text-center lg:text-left">
                    <div className="flex justify-center lg:justify-start mb-8 lg:hidden ">
                        <img className="rounded-full shadow-xl h-40 w-40" src={p1} alt="Profile" />
                    </div>

                    <h1 className="text-3xl font-semibold text-gray-900">Gayan Madusanka (Madhu)</h1>
                    <div className="my-4 w-16 border-t-2 border-green-500 mx-auto lg:mx-0 opacity-25" />
                    <p className="text-xl text-gray-700 font-bold mb-4">Founder & CEO, No Limit Tour Randombe</p>
                    <p className="text-sm text-gray-600 mb-6">Randombe, Sri Lanka</p>

                    <p className="text-sm text-gray-600 mb-8">
                        At No Limit Tour Randombe, we create unforgettable travel experiences tailored to every traveler. From relaxing getaways to adventurous tours, we ensure each journey is seamless, enjoyable, and memorable. Our team is passionate about making your travels stress-free, so you can focus on exploring new destinations and creating lasting memories.
                    </p>

                    <button className="bg-green-700 text-white font-bold py-2 px-4 rounded-full hover:bg-green-800 transition duration-300">
                        Get In Touch
                    </button>

                    {/* Social Media Icons */}
                    <div className="mt-6 flex justify-center lg:justify-start space-x-6">
                        <a href="#" className="text-gray-600 hover:text-green-700 transition duration-300">
                            <FaFacebook className="h-6" />
                        </a>
                        <a href="#" className="text-gray-600 hover:text-green-700 transition duration-300">
                            <FaTwitter className="h-6" />
                        </a>
                        <a href="#" className="text-gray-600 hover:text-green-700 transition duration-300">
                            <FaGithub className="h-6" />
                        </a>
                        <a href="#" className="text-gray-600 hover:text-green-700 transition duration-300">
                            <FaInstagram className="h-6" />
                        </a>
                        <a href="#" className="text-gray-600 hover:text-green-700 transition duration-300">
                            <FaYoutube className="h-6" />
                        </a>
                    </div>
                </div>

                {/* Image Column for large screens */}
                <div className="w-full lg:w-2/5 hidden lg:block">
                    <img className="w-full h-full object-cover rounded-lg shadow-2xl" src={p1} alt="Profile Background" />
                </div>
            </div>
        </div>
    );
};

export default Owner;
